// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table, Button, Input } from 'semantic-ui-react';
import _ from 'lodash';
// local
// css
import './Device.scss';
// libs
import t from 'app/lib/i18n';
// views
import Page from 'app/ui/pages/Page';
import DeviceModal from 'app/ui/modal/DeviceModal';
import EmptyList from 'app/ui/commons/emptyList/EmptyList';
// consts
import { TYPE as CLIENT_TYPE } from 'salvus-shared/consts/client';
import { TYPE as DEVICE_TYPE } from 'salvus-shared/consts/device';
// actions
import { openSave, openUpdate, TYPE } from 'app/redux/actions/modal';
import { list, search, reset } from 'app/redux/actions/device';

class Devices extends Component {
    constructor(props) {
        super(props);
        this.callSearch = _.debounce(this.callSearch, 100);
        this.state = {
            search: props.device.filter.term,
        };
    }

    // Handler for the change in the input
    onSearchChange = (e, { value }) => {
        this.setState({ search: value });
        this.callSearch(value);
    };

    callSearch = value => this.props.dispatch(search(value));

    componentDidMount = () => this.props.dispatch(list());

    componentWillUnmount = () => this.props.dispatch(reset());

    onClickAdd = () => this.props.dispatch(openSave(TYPE.DEVICE));

    onClickEdit = device => () => this.props.dispatch(openUpdate(TYPE.DEVICE, device));

    renderEmpty = () => <EmptyList emptyMessage="Nenhum dispositivo encontrado." />;

    bateryState(batery, type) {
        switch (type) {
            case DEVICE_TYPE.CONCENTRATOR: {
                const rawCapibility = batery - 3;
                let capibility = rawCapibility <= 0 ? 0 : `${parseInt((100 * rawCapibility) / 1.2, 10)}`;
                if (capibility > 100) capibility = 100;
                return `${capibility}%`;
            }
            default: {
                let capibility = batery > 3.8 ? parseInt(100 - (4.3 - batery)*(80/0.5), 10) : parseInt(20 - (3.8 - batery)*(15/0.5), 10);
                if (capibility > 100) capibility = 100;
                else if (capibility < 0) capibility = 0;
                return `${capibility}%`;
            }
        }
    }
    renderTable(data) {
        const { auth } = this.props;
        return (
            <Table id="list-device">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell width="2">Identificador</Table.HeaderCell>
                        <Table.HeaderCell width="2">Tipo</Table.HeaderCell>
                        {auth.account.client.type === CLIENT_TYPE.SALVUS ? <Table.HeaderCell width="5">Cliente</Table.HeaderCell> : null}
                        <Table.HeaderCell width="5">Paciente</Table.HeaderCell>
                        <Table.HeaderCell width="1">Bateria</Table.HeaderCell>
                        <Table.HeaderCell width="1">Status</Table.HeaderCell>
                        <Table.HeaderCell width="1" />
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {_.map(data, row => {
                        const { id, key, type, client, clientId, patient, patientId, status, batery } = row;
                        const statusKey = `device_status_${status}`;
                        const clientName = clientId ? client.name : '-';
                        const patientName = patientId ? patient.name : '-';
                        return (
                            <Table.Row key={id}>
                                <Table.Cell width="2" className="wrap">
                                    {key}
                                </Table.Cell>
                                <Table.Cell width="2" className="wrap">
                                    {t(`device_type_${type}`)}
                                </Table.Cell>
                                {auth.account.client.type === CLIENT_TYPE.SALVUS ? (
                                    <Table.Cell width="5" className="wrap">
                                        {clientName}
                                    </Table.Cell>
                                ) : null}
                                <Table.Cell className="uppercase wrap" width="5">
                                    {patientName}
                                </Table.Cell>
                                <Table.Cell className="batery" width="1">
                                    {status === 0 ? 'sem dado' : this.bateryState(batery, type)}
                                </Table.Cell>
                                <Table.Cell className={statusKey} width="1">
                                    {t(statusKey)}
                                </Table.Cell>
                                <Table.Cell textAlign="right" width="1">
                                    <Button circular icon="edit" onClick={this.onClickEdit(row)} />
                                </Table.Cell>
                            </Table.Row>
                        );
                    })}
                </Table.Body>
            </Table>
        );
    }

    render() {
        const { auth, device } = this.props;
        const { filter, loading } = device;
        return (
            <Page id="page-device" loading={loading}>
                <div className="page-header">
                    <div className="page-title">DISPOSITIVOS</div>
                    {auth.account.client.type === CLIENT_TYPE.SALVUS && <Button content="Adicionar" onClick={this.onClickAdd} />}
                </div>
                <div className="body">
                    <div className="body-header">
                        <Input id="device-search" placeholder="Pesquisar..." className="search" onChange={this.onSearchChange} value={this.state.search} />
                    </div>
                    {_.isEmpty(filter.data) ? this.renderEmpty() : this.renderTable(filter.data)}
                </div>
                <DeviceModal />
            </Page>
        );
    }
}

Devices.propTypes = {
    device: PropTypes.object,
    auth: PropTypes.object,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    auth: state.auth,
    device: state.device,
});
export default connect(mapStateToProps)(Devices);
